import axios from "../../Uri";

export const getTodaysCheckOuts = (buildingId) => {
  return axios.get(`/guest/findTodayOut/${buildingId}`);
};

export const getExceededCheckOutList = (buildingId) => {
  return axios.get(`/guest/findExceedGuest/${buildingId}`);
};
